import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { usePlanBT } from '../../../../hooks'
import PlanBTListView from './PlanBTListView/PlanBTListView'
import Pagination from '../../../../../../common/components/organisme/Pagination/Pagination'
import minigridAPI from '../../../../../minigrid/service/minigridAPI'
import { useAuth } from '../../../../../auth/hooks'
import { useCapability } from '../../../../../rbac'

export default function PlanBTListPresenter() {
  const { allPlanBTQuery:{data, isLoading, isError, error, setPage}, deletePlanBT} = usePlanBT()
  const { getAccountIdUser } = useAuth()
  // RBAC : édition d'un plan = planbt.edit, suppression du plan entier = planbt.delete.
  const canEdit = useCapability('planbt.edit')
  const canDelete = useCapability('planbt.delete')
  const accountId = getAccountIdUser()

  const allMinigridsQuery = useQuery({
    queryKey: ['allMinigridsByAccount', accountId],
    queryFn: () => minigridAPI.getAllMinigrids(0, 0, { accountId }),
    enabled: Boolean(accountId),
    staleTime: 5 * 60 * 1000,
  })

  const minigridNameById = React.useMemo(() => {
    const map: Record<string, string> = {}
    for (const mg of allMinigridsQuery.data?.data ?? []) {
      map[mg.minigrid_id] = mg.minigrid_name
    }
    return map
  }, [allMinigridsQuery.data])

  const navigate = useNavigate()

  const handleDelete = (planBTId: string) => {
    deletePlanBT.mutate({planBTId})
  }

  const goToSinglePlan = (planBTId: string) => {

    navigate(`/main/plan-bt-v2/${planBTId}`)
  }

  const goToEdit = (planBTId: string) => {
    navigate(`/main/plan-bt/${planBTId}/edit`)
  }

  if (isError){
    return <div>{error.message} status {error.response?.status}</div>
  }
  return (
    <>

    <PlanBTListView
      planList={data?.data}
      deletePlanBTHandler={canDelete ? handleDelete : undefined}
      goToSinglePlan={goToSinglePlan}
      goToEditPlanBT={canEdit ? goToEdit : undefined}
      isLoading={isLoading}
      minigridNameById={minigridNameById}
    />
    { !isLoading &&
    <Pagination centered currentPage={data?.pagination.current_page} lastPage={data?.pagination.total_pages} setCurrentPage={setPage}/>
    }
    </>
  )
}
